module.exports = __webpack_public_path__ + "static/people_pop20-0bc96d17a8f0f44686df1dc51afd59e3.png";